/** Staged at `/finance-pro/job-templates`; the legacy dashboard stays the live UI. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, JobTemplateEntity } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';
import { entityRecordUrl } from '@workbuddy/ui/v2/blocks/entity.record';

export const JOB_TEMPLATE_SLUG = 'job-template';

/**
 * System view "All Job Templates". Composed from the same enum the server composes it from
 * (`job.template.system.views.ts`), so renaming the entity cannot silently unlink the two.
 */
export const JOB_TEMPLATE_ALL_VIEW_ID = `${ActivityEntityName.JobTemplate}-all`;

export function jobTemplateRecordRoute(id: string): string {

  return entityRecordUrl(JOB_TEMPLATE_SLUG, 'edit', id)!;
}

export async function navigateToJobTemplateManage(item: JobTemplateEntity): Promise<void> {

  if (!item?._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.JobTemplate,
    id: item._id,
  });
}
